import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import { DomainSearchSuiteModule, PricingContent } from '@wix/domains-search-suite';
import { PerceptionNote } from './PerceptionNote';
import { PerceptionNotePlaceholder } from './PerceptionNotePlaceholder';
import { perceptionRowFor, withVoucherClaim } from './perceptionRows';
import { useVoucherEligibleTld } from './useVoucherEligibleTld';
import s from './perceptionPricing.module.scss';
const DOMAIN_PRICE_KEY = 'domain_search_suite.domain_gate.suggestions.card.domain_price';
const ReframedRow = _ref => {
  let {
    pricing,
    noteBelowPrice = true,
    emphasizePrice = false,
    row
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const price = pricing[row.priceFrom];
  const strikethrough = pricing[row.strikethroughFrom];
  const tooltip = t(row.tooltipKey, {
    price: pricing.renewalPrice,
    renewalPrice: pricing.renewalPrice
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "0",
    className: s.priceStack
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "0 SP1",
    verticalAlign: "bottom",
    flexWrap: "wrap"
  }, strikethrough && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    secondary: true,
    light: true,
    className: s.struck
  }, t(DOMAIN_PRICE_KEY, {
    domainPrice: strikethrough
  })), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "normal",
    className: emphasizePrice ? `${s.pricePerception} ${s.positivePrice}` : s.pricePerception
  }, row.perYear ? t(DOMAIN_PRICE_KEY, {
    domainPrice: price
  }) : price)), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "center",
    verticalAlign: "middle",
    gap: "2px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t(row.labelKey)), /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip,
    maxWidth: "250px",
    appendTo: "scrollParent",
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon,
    "data-hook": "perception-info-icon"
  })))), noteBelowPrice && (row.note || row.claimPending) && /*#__PURE__*/React.createElement(Box, {
    marginTop: "3px"
  }, row.note ? /*#__PURE__*/React.createElement(PerceptionNote, {
    labelKey: row.note.labelKey,
    withIcon: row.note.withIcon
  }) : /*#__PURE__*/React.createElement(PerceptionNotePlaceholder, null)));
};
const PerceptionPriceContent = _ref2 => {
  let {
    noteBelowPrice,
    emphasizePrice,
    content,
    ...suiteProps
  } = _ref2;
  const isVoucherEligible = useVoucherEligibleTld();
  const row = withVoucherClaim(perceptionRowFor(suiteProps.pricing, content), isVoucherEligible(suiteProps.tld));
  return row ? /*#__PURE__*/React.createElement(ReframedRow, _extends({}, suiteProps, {
    noteBelowPrice: noteBelowPrice && !suiteProps.exactMatch,
    emphasizePrice: emphasizePrice,
    row: row
  })) : /*#__PURE__*/React.createElement(PricingContent, suiteProps);
};
export const priceContentFor = (content, _ref3) => {
  let {
    noteBelowPrice,
    emphasizePrice
  } = _ref3;
  const PriceContent = props => /*#__PURE__*/React.createElement(PerceptionPriceContent, _extends({}, props, {
    content: content,
    noteBelowPrice: noteBelowPrice,
    emphasizePrice: emphasizePrice
  }));
  return PriceContent;
};
//# sourceMappingURL=PerceptionPriceContent.js.map